// Central config — use BACKEND_URL instead of process.env.REACT_APP_BACKEND_URL directly
// so every build works even when the env var is not set (relative URLs via nginx proxy).
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// s158 opportunity mini-sites: this same build is also served on client
// subdomains (e.g. opportunitybeta.acapitalgroup.com). A "foreign" host is any
// host other than the brand's own (www-insensitive); localhost never is.
export const IS_FOREIGN_HOST = (() => {
  try {
    const host = window.location.hostname.replace(/^www\./, '');
    if (!BACKEND_URL || /localhost|127\.0\.0\.1/.test(host)) return false;
    return new URL(BACKEND_URL).hostname.replace(/^www\./, '') !== host;
  } catch (_) { return false; }
})();
